import { memo } from 'react'
import LazySvg from 'components/LazyImage'
import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  banner: {
    margin: '0 -16px',
    padding: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[50]
  }
}))

const TvLogoBanner = () => {
  const { banner } = useStyles()
  return (
    <div className={banner}>
      <LazySvg
        src={() => import('../../assets/logos/tv_logos.svg')}
        alt="TV Logo Banner"
        height={20}
      />
    </div>
  )
}

export default memo(TvLogoBanner)
